var map = {
	"./d-1@2x.png": 71224,
	"./editor-placeholder.svg": 67263,
	"./greenhouse@2x.png": 33426,
	"./hero@2x.png": 73983,
	"./mountain-silhouette@2x.png": 10691,
	"./quote-1@2x.png": 71815,
	"./quote-2@2x.png": 48527,
	"./skeleton-flowers@2x.png": 82856
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89211;